<div
  class="zag-number-input"
  [class.zag-number-input--disabled]="disabled() || readonly()"
  [class.zag-number-input--flush-right]="flushRight()"
>
  @if (showControls()) {
  <button
    type="button"
    class="zag-number-input-control"
    [disabled]="!canDecrement()"
    [attr.aria-label]="'Decrement value'"
    (click)="decrement()"
  >
    -
  </button>
  }

  <input
    class="zag-number-input-field"
    type="number"
    [style.text-align]="textAlign()"
    [value]="displayValue()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [id]="id()"
    [name]="name()"
    [autocomplete]="autocomplete()"
    [required]="required()"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur()"
  />

  @if (suffix()) {
  <span class="zag-number-input-suffix">{{ suffix() }}</span>
  } @if (clearable()) {
  <button
    type="button"
    class="zag-number-input-clear"
    [class.zag-number-input-clear--hidden]="!showClearButton()"
    [attr.aria-label]="'Clear value'"
    [attr.aria-hidden]="!showClearButton()"
    [attr.tabindex]="showClearButton() ? 0 : -1"
    (click)="clear($event)"
  >
    <span zagIcon="close"></span>
  </button>
  } @if (showControls()) {
  <button
    type="button"
    class="zag-number-input-control"
    [disabled]="!canIncrement()"
    [attr.aria-label]="'Increment value'"
    (click)="increment()"
  >
    +
  </button>
  }
</div>
